export default "__VITE_ASSET__CNr4y_ZJ__"